import React from 'react';
import classes from './NavigationItem.css';
import { NavLink } from 'react-router-dom';

const navigationItem = (props) => {
  let clickAction = null;
  if (props.openState) {
    clickAction = props.closeDrawer
  }
  return <li className={classes.NavItem}>
    <NavLink
      onClick={clickAction}
      to={`${props.link}`}
      activeClassName={classes.active}>
      {props.name}
    </NavLink>
  </li>
}

export default navigationItem;


// WEBPACK FOOTER //
// ./src/components/Navigation/NavigationItems/NavigationItem/NavigationItem.jsx